import Head from 'next/head';
import Image from 'next/image';
import React, { useState } from 'react';

import shield from '@/assets/images/shield.svg';
import { Faqcomponent } from '@/common/components/Faq/FaqComponent';
import CallbackForm from '@/common/components/Forex/CallBackForm';
import BuyReason from '@/common/components/Forex/LandingPage/BuyReason';
import BuySteps from '@/common/components/Forex/LandingPage/BuySteps';
import LiveExchangeRates from '@/common/components/Forex/LandingPage/LiveExchangeRates';
import type { Item, UserDetails } from '@/common/components/Forex/LeadForm';
import LeadForm from '@/common/components/Forex/LeadForm';
import { BuyForexFaq } from '@/utils/constants/forex/faq/index';
import { BuyForexSEO } from '@/utils/constants/MetaData';

export type LeadStore = {
  items: Item[];
  userDetails: UserDetails;
};

const BuyForex = () => {
  const [activeStep, setActiveStep] = useState<number>(1);

  const [leadState, setLeadState] = useState<LeadStore>({
    items: [],
    userDetails: {
      userName: '',
      userEmail: '',
      userPhone: '',
      userCity: '',
      userState: '',
    },
  });

  const handleActiveStep = (step: number) => {
    setActiveStep(step);
  };

  return (
    <>
      <Head>
        <title>{BuyForexSEO.metaTitle}</title>
        <meta name="description" content={BuyForexSEO.metaDescription} />
        <meta
          property="og:description"
          content={BuyForexSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/forex/buy-forex/"
        />
      </Head>
      <main className="home withNavHeader bg-prelogin fx">
        {/* Hero section */}
        <section className="bg bg--dark bg--sky home__hero fx-trim-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 margin-26-px order-1">
                <h1 className="section__title text--white">
                  Buy Forex at Competitive Rates
                </h1>
                <p className="section__desc text--white">
                  Get multi-currency card or cash at your convenience
                </p>
                <div className="d-flex align-items-center appLinks four-fifty-logo">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={shield}
                    alt="shiled"
                  />
                </div>
              </div>
              <div className="col-lg-7 order-3">
                {activeStep === 1 && (
                  <LeadForm
                    type={'BUY'}
                    activeStep={activeStep}
                    handleStep={handleActiveStep}
                    setLeadState={setLeadState}
                    leadState={leadState}
                  />
                )}
                {activeStep === 2 && (
                  <CallbackForm
                    activeStep={activeStep}
                    handleStep={handleActiveStep}
                    leadState={leadState}
                    setLeadState={setLeadState}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Live exchange rates section */}
        <LiveExchangeRates />

        {/* Reasons to Buy Sell Forex */}
        <BuyReason />

        {/* 4 Easy Steps for Forex */}
        <BuySteps />

        {/* Customer Testimonial */}
        {/* TODO After we get customer Testimonials */}
        {/* <Testimonials/> */}

        {/* FAQ's for Forex */}
        {/* Todo After we get the updated content */}
        <Faqcomponent faqData={BuyForexFaq()} />
      </main>
    </>
  );
};

export default BuyForex;
